import DynamicFieldsFragment from '@linc-technologies/linced-common/models/dynamic-field/base-fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: people.BulkImportCaregiver.
export default class BulkImportCaregiver extends DynamicFieldsFragment {
  declare [Type]: 'people/bulk-import-caregiver';

  // personId is the existing Hero Person ID, if known / applicable.
  @attr('string', { defaultValue: '' })
  declare personId: string;
}
